import React, { useEffect, useMemo, useState } from "react";
import "./PageStyles.scss";
import { useDispatch, useSelector } from "react-redux";

import ChatListItem from "../../components/molecules/ChatListItem";
import {
  getChats,
  clearCurrentChat,
  getUserChat,
  getCurrentChat,
  markChatRead
} from "../../redux/actions/ChatActions";
import ChatRoom from "../organisms/ChatRoom";

export default function ChatListScreen() {
  const dispatch = useDispatch();
  const user = useSelector(state => state.account.user);
  const chats = useSelector(state => state.chat.chats);
  const impersonatedUser = useSelector(state => state.account.impersonatedUser);

  const [selectedChat, setSelectedChat] = useState(null);

  useEffect(() => {
    dispatch(getChats());
  }, []);

  const chatItems = useMemo(() => {
    if (!chats) return [];
    return chats.map(chat => {
      let name, avatar;
      if (chat.lastSender !== user.id) {
        name = chat.userNames[chat.lastSender];
        avatar = chat.photos[chat.lastSender];
      } else {
        const other = chat.members.find(id => id !== user.id);
        name = chat.userNames[other];
        avatar = chat.photos[other];
      }
      return {
        id: chat.id,
        date: chat.date,
        preview: chat.lastMessage,
        name,
        avatar,
        unread: chat.unread || false
      };
    });
  }, [chats, user.id]);

  const handleSelectChat = chat => {
    setSelectedChat(chat);
    const chatId = chat.id;
    if (chatId) {
      dispatch(clearCurrentChat());
      dispatch(getCurrentChat(chatId, true));
      dispatch(markChatRead(chatId));
    } else {
      dispatch(getUserChat(user.id));
    }
  };

  const containerClass = `chat_container ${impersonatedUser !== null ? "chat_container--impersonated" : "chat_container--normal"}`;

  return (
    <div className={containerClass}>
      <div className="chat_container__list">
        {chatItems.map(item => (
          <ChatListItem
            key={item.id}
            item={item}
            activeChat={selectedChat}
            selected={handleSelectChat}
          />
        ))}
      </div>
      {selectedChat ? (
        <ChatRoom
          selectedChat={selectedChat}
          messages={[]}
        />
      ) : (
        <div className="chat_empty_state">
          <p className="chat_empty_state__text">Select a conversation to start messaging</p>
        </div>
      )}
    </div>
  );
}
